import Add from '../components/Holidays/Add'
import Crud from '../components/Holidays/Crud'
let routes = {
    path: '/holidays',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/holidays',
            name: 'Feriados',
            component: Crud
        },
        {
            path: '/holidays/add',
            name: 'Novo Feriado',
            component: Add
        },
        {
            path: '/holidays/edit/:id?',
            name: 'Editar - Feriados',
            component: Add
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/holidays.js